// Wind sessions list page — active cards + stopped history cards.
// Mirrors legacy loadWindTrades + renderWindCard + renderWindClosedCard.
import { useState } from "react";
import { useWindSessions } from "@/hooks/use-wind-sessions";
import WindCard from "@/components/wind/wind-card";
import WindStoppedCard from "@/components/wind/wind-stopped-card";
import CreateWindModal from "@/components/wind/create-wind-modal";

export default function WindPage() {
  const { data, isLoading, error } = useWindSessions();
  const [hideStopped, setHideStopped] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  const active = data?.active_sessions ?? [];
  const history = [...(data?.history_sessions ?? [])].sort((a, b) => {
    const ta = new Date(a.session.stopped_at ?? a.session.created_at).getTime();
    const tb = new Date(b.session.stopped_at ?? b.session.created_at).getTime();
    return tb - ta;
  });

  return (
    <div>
      {/* Heading + controls — flex-wrap keeps the action pair together on
          narrow screens; they drop below the heading instead of each button
          wrapping independently. */}
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3 px-0.5">
        <h2 className="text-sm font-semibold text-text">
          Wind Trades{" "}
          <span className="text-muted font-normal text-xs">
            {active.length} active · {history.length} stopped
          </span>
        </h2>
        <div className="flex items-center gap-2 flex-shrink-0 ml-auto">
          <button
            className={`inline-flex items-center h-7 px-3 text-xs font-medium rounded border transition-colors ${
              hideStopped
                ? "border-accent/60 text-accent bg-accent/10"
                : "border-border text-muted hover:text-text"
            }`}
            onClick={() => setHideStopped((v) => !v)}
          >
            Hide stopped
          </button>
          <button
            className="inline-flex items-center h-7 px-3 text-xs font-medium rounded border border-accent/50 text-accent bg-accent/10 hover:bg-accent/20 transition-colors"
            onClick={() => setShowCreate(true)}
          >
            + New Wind
          </button>
        </div>
      </div>

      {/* Loading / error states */}
      {isLoading && (
        <div className="text-muted text-sm text-center py-8">Loading…</div>
      )}
      {error && (
        <div className="text-danger text-sm text-center py-8">
          Failed to load wind trades
        </div>
      )}

      {/* Cards */}
      {!isLoading && !error && (
        <div className="space-y-2">
          {active.map((row) => (
            <WindCard key={row.session.id} row={row} />
          ))}
          {!hideStopped &&
            history.map((row) => (
              <WindStoppedCard key={row.session.id} row={row} />
            ))}
          {active.length === 0 && (hideStopped || history.length === 0) && (
            <div className="text-muted text-sm text-center py-8">
              No wind trades yet
            </div>
          )}
        </div>
      )}

      {showCreate && <CreateWindModal onClose={() => setShowCreate(false)} />}
    </div>
  );
}
